const getters = {
    accessToken: (state) => state.accessToken,
    refreshToken: (state) => state.refreshToken,
    isAuthenticated: (state) => state.isAuthenticated,
    authorities: (state) => state.authorities,
    email: (state) => state.email,
}

export default getters